import { MenuSeparatorTheme, variants, styles } from '../MenuSeparatorStyles.css';
import { baseTheme } from './MenuSeparatorBaseTheme.css';
import { multiVariantStyles } from './MenuSeparatorVariants.css';

const MenuSeparatorRedwoodTheme: MenuSeparatorTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

export { MenuSeparatorRedwoodTheme };
